module.exports = __webpack_public_path__ + "img/purpleBellflower.4879a57d.jpeg";